import { AccountsSelectTableDialog } from '../../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/AccountsSelectTableDialog';
import { AccountsSelectedTable } from '../../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/AccountsSelectedTable';
import { AccountContext } from '../../../../../ui/features/badge-management/contexts/AccountContext';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { Alert, Box } from '@mui/material';
import React from 'react';
export const BadgeAccountsSelectionPanel = ({ selectedAccounts, setSelectedAccounts, selectedAccountsTableInfoText, initialStorageAccountFilters, showAccountSelectDialogInitially, sx, onClose, onEscapeKeyDown, }) => {
    const { t } = useBadgingTranslation();
    const [isAccountsSelectionSaved, setIsAccountsSelectionSaved] = React.useState(false);
    const { mapAccountToAccountSelection, adjustAccountSelectionChanged, extendAddAccountFilters, extendAccountSelectionSelectColumns, extendAccountSelectionSelectedColumns, } = React.useContext(AccountContext);
    const handleChangeAccountSelections = (selectedAccounts) => {
        setSelectedAccounts(() => selectedAccounts.map(adjustAccountSelectionChanged));
        setIsAccountsSelectionSaved(true);
    };
    const handleRemoveSelectedAccounts = React.useCallback((idsToRemove) => {
        setSelectedAccounts((prevAccounts) => prevAccounts.filter((c) => !idsToRemove.includes(c.id)));
    }, [setSelectedAccounts]);
    const handleChangeAccountSelectionOptions = React.useCallback((accountId, optionsPartialChanges) => {
        setSelectedAccounts((accounts) => accounts.map((acc) => acc.id === accountId
            ? adjustAccountSelectionChanged(Object.assign(Object.assign({}, acc), { options: Object.assign(Object.assign({}, acc.options), optionsPartialChanges) }))
            : acc));
    }, [adjustAccountSelectionChanged, setSelectedAccounts]);
    const handleAddAccount = () => {
        showCustomDialog({
            fullScreen: true,
            content: (close) => {
                return (React.createElement(AccountsSelectTableDialog, { initialStorageClientFilter: initialStorageAccountFilters, selectedAccounts: selectedAccounts, mapToSelectedAccount: mapAccountToAccountSelection, onSaveAccountSelection: handleChangeAccountSelections, renderColumns: extendAccountSelectionSelectColumns, accountTableExtendFilters: extendAddAccountFilters, onClose: (closed, fullClose) => {
                        close(closed);
                        if (fullClose && !isAccountsSelectionSaved) {
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                        }
                    } }));
            },
            onEscapeKeyDown: (close) => {
                close();
                if (!isAccountsSelectionSaved) {
                    onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown();
                }
            },
        });
    };
    const hasAutoShownRef = React.useRef(false);
    React.useEffect(() => {
        if (showAccountSelectDialogInitially && !hasAutoShownRef.current) {
            hasAutoShownRef.current = true;
            handleAddAccount();
        }
        // only for first render!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(Box, { sx: Object.assign({ width: '100%', p: 2, display: 'flex', flexDirection: 'column' }, sx) },
        React.createElement(AccountsSelectedTable, { selectedAccounts: selectedAccounts, onAddAccountClick: handleAddAccount, onUnselectAccounts: handleRemoveSelectedAccounts, onSetSelectedAccountOptions: handleChangeAccountSelectionOptions, renderColumns: extendAccountSelectionSelectedColumns === null || extendAccountSelectionSelectedColumns === void 0 ? void 0 : extendAccountSelectionSelectedColumns(setSelectedAccounts), tableTitle: t('badges.create.wizard.step3.accountSelection.selectedAccounts'), tableRowSelectionEnabled: true }),
        Boolean(selectedAccountsTableInfoText) && (React.createElement(Alert, { sx: { mt: 2 }, severity: 'info' }, selectedAccountsTableInfoText))));
};
